import { ApiEndpointUrl } from "../../common";
export const ordersPoint = {
    list: ApiEndpointUrl + "orders",
    returnrequest: ApiEndpointUrl + "savereturnrequest",
    rmslist: ApiEndpointUrl + "rms/orderreturnlist",
};
